import { useMemo } from 'react';
import { Grid, Typography } from '@mui/material';
import { FormPart } from '@modules/shared/components/FormPart';
import { formatDate, getOptions } from '@shared/commonFunctions';
import { dateFormatWithTime } from '@shared/constants/formats';
import { CheckboxListField } from '@shared/fields/CheckboxListField';
import { TextInputField } from '@shared/fields/TextInputField';
import { FlexEnd } from '@styles/StyledDiv';

import { SaveButton } from '@shared/inputs/Buttons';
import { IComments, ITitleDocumentsFormProps } from '../../../interfaces';

interface INoteProps {
  label: string;
  comments: IComments[];
}

const Note = ({ label, comments }: INoteProps) => (
  <>
    <Typography variant="subtitle1">{label}</Typography>

    {comments.map((item) => {
      return (
        <>
          <Grid container pt={1}>
            <Grid item xs={8}>
              <Typography>{item.comment}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="caption">{formatDate(item.createdDate, { format: dateFormatWithTime })}</Typography>
            </Grid>
          </Grid>
        </>
      );
    })}
  </>
);

export const TitleDocumentsForm = ({ values }: ITitleDocumentsFormProps) => {
  const titledocumentsForm = useMemo(
    () => [
      {
        label: 'Titles DocGen CheckList',
        name: 'selectedItems',
        options: getOptions(values.items, 'documentName', 'documentName'),
        nextLine: true,
        component: CheckboxListField,
      },
      {
        width: '100%',
        component: Note,
        label: 'Notes',
        comments: values.comments || [],
      },
      {
        label: 'Comments',
        width: '100%',
        name: 'comment.comment',
        minRows: 3,
        multiline: true,
        component: TextInputField,
      },
    ],
    [values.items],
  );

  return (
    <>
      <FormPart config={titledocumentsForm} />
      <FlexEnd>
        <SaveButton disabled={!values.selectedItems.length}/>
      </FlexEnd>
    </>
  );
};
